'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EResourceLink = function EResourceLink(_ref) {
  var eresourceDescription = _ref.eresourceDescription,
      eresourceUrl = _ref.eresourceUrl,
      format = _ref.format,
      intl = _ref.intl;

  var resourceText = eresourceDescription || intl.formatMessage({ id: 'full_download_' + format.toLowerCase() });
  return _react2.default.createElement(
    'a',
    { className: 'cp-eresource-link', href: eresourceUrl, target: '_blank', rel: 'noopener noreferrer' },
    _react2.default.createElement(
      'span',
      { 'aria-hidden': 'true' },
      resourceText,
      '\xA0',
      _react2.default.createElement(_baseIcons.NewTab, { color: 'currentColor' })
    ),
    _react2.default.createElement(
      _baseScreenReaderMessage2.default,
      null,
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_link_opens_new_window', values: { linkText: resourceText } })
    )
  );
};

EResourceLink.propTypes = {
  eresourceUrl: _react.PropTypes.string.isRequired,
  eresourceDescription: _react.PropTypes.string,
  format: _react.PropTypes.string,
  intl: _reactIntl.intlShape
};

EResourceLink.displayName = 'EResourceLink';

exports.default = (0, _reactIntl.injectIntl)(EResourceLink);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-eresource-link/lib/components/EResourceLink.component.js
// module id = 1482
// module chunks = 1